import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";

const CumpleTemplate = lazy(() => import("@/components/templates/CumpleTemplate"));

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "linear-gradient(135deg, #92400e 0%, #7c3aed 100%)" }}>
      <div className="text-center space-y-4">
        <Loader2 className="w-12 h-12 animate-spin text-amber-400 mx-auto" />
        <p className="text-white/80 text-sm">Cargando...</p>
      </div>
    </div>
  );
}

export default function RegaloCumple() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <CumpleTemplate />
    </Suspense>
  );
}
